import { useEffect } from 'react';
import { $ as $62d8ded9296f3872$export$cfa2225e87938781 } from '../3rdPartyModules/_react-aria/utils/dist/getScrollParent-H-XNisVX.js';
import { g as getElement } from './getElement-zsbq1uP4.js';
import { u as useHandlerRef } from '../LocalModules/storm-ui-utils/dist/esm/useHandlerRef-aaEiZjUW-aaEiZjUW.js';

/**
 * OnTargetMove attaches a scroll event listener to both the window and the
 * first ancestor if the element that scrolls.
 *
 * The OnTargetMove component ensures that `scroll` event listener are
 * cleaned-up when it ( or its ancestor ) is un-mounted. This us useful to prevent leaving
 * unused listener attached after a un-mounted when the parent's lifecycle control's child
 * mount states
 */
const OnTargetMove = ({
  targetEl,
  children,
  handler: handlerArg
}) => {
  const handlerArgRef = useHandlerRef(handlerArg);
  useEffect(() => {
    /**
     * get references to the target and first scrolling parent element
     */
    const target = getElement(targetEl);
    const scrollParent = target && $62d8ded9296f3872$export$cfa2225e87938781(target);
    function handler(event) {
      if (typeof handlerArgRef.current === 'function') {
        handlerArgRef.current(event);
      }
    }

    /**
     * listen for window scrolling
     */
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handler);
    }

    /**
     * if the scrollParent is not the top `<html/>`, listen for element scrolling
     */
    if (scrollParent && typeof document !== 'undefined' && scrollParent !== document.documentElement) {
      scrollParent.addEventListener('scroll', handler);
    }

    /**
     * listen for visualViewport resizes or fall back to window if the
     * visualViewport API is not available.
     */
    if (typeof window !== 'undefined' && 'visualViewport' in window && window.visualViewport) {
      window.visualViewport.addEventListener('resize', handler);
    } else if (typeof window !== 'undefined') {
      window.addEventListener('resize', handler);
    }
    return () => {
      /**
       * clean up any of the listeners
       */
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handler);
      }
      if (scrollParent) {
        scrollParent.removeEventListener('scroll', handler);
      }
      if (typeof window !== 'undefined' && 'visualViewport' in window && window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handler);
      } else if (typeof window !== 'undefined') {
        window.addEventListener('resize', handler);
      }
    };
  }, [targetEl, handlerArgRef]);
  return children;
};

export { OnTargetMove as O };
//# sourceMappingURL=OnTargetMove-UrZt4VFG.js.map
